import { Environment } from "@coxauto-ui/cxm/communications/interfaces";
import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import {
  GetDealerCommunicationDetailsByConsumerIdRequest,
  GetDealerCommunicationDetailsByConsumerIdResponse
} from "./interfaces/get-dealer-communication-details-by-consumer-id";

/** Returned when the endpoint fails (e.g. 500).
 * Setting canProceed: false causes the Texting Unavailable alert to show
 * and locks the text reply UI, while still allowing the rest of the inbox to load normally.
 */
const ERROR_FALLBACK: GetDealerCommunicationDetailsByConsumerIdResponse = {
  dealerPhoneNumber: {
    phoneNumber: "unknown",
    campaignApproved: true,
    isPhoneNumberReady: true,
    canProceed: false
  },
  userPhoneNumbers: []
};

export async function getDealerCommunicationDetailsByConsumerId(
  data: GetDealerCommunicationDetailsByConsumerIdRequest,
  env: Environment
): Promise<GetDealerCommunicationDetailsByConsumerIdResponse> {
  try {
    const url = `${getBaseUrl(
      env
    )}cxm/dealer-communication-details-by-consumerId`;
    const header = await getHeader();

    const response =
      await fetchWrapper.getAsync<GetDealerCommunicationDetailsByConsumerIdResponse>(
        `${url}?consumerId=${data.consumerId}&ConsumerRecordSystem=${data.consumerRecordSystem}`,
        header
      );

    if (!response || !response.data || response.hasError) {
      throw new Error(
        response.error?.message || "An unexpected error occurred"
      );
    }

    return response.data;
  } catch (error: unknown) {
    console.error(
      "[CustomerConversation] Failed to load dealer communication details. Texting will be locked.",
      error
    );
    return ERROR_FALLBACK;
  }
}
